var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M34.3 4.4l-7.2 11.3-6.5.4 9.7 6.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.2 18.5l-9.7 4.8s4.4 7 10.5 9.7c2.8 1.3 6.2-4.2 6.2-4.2M29.8 27.2s-1 3.7-2.4 5.7-3.3 3.5-3.3 3.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 34.3,
    cy: 33.9,
    r: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanFilter);
export default __webpack_public_path__ + "static/media/cleanFilter.4c1902af93bdcf15ef9a17ea056aaa5c.svg";
export { ForwardRef as ReactComponent };